import { gql } from "@apollo/client";

export const CreateInstalledBaseEvent = gql`
    mutation CreateInstalledBaseEvent (
        $event: InstalledBaseEventInput!,
        $attributes: [InstalledBaseEventAttributeInput!]!
    ) {
        createInstalledBaseEvent (
            event: $event,
            attributes: $attributes
        ) {
            id
            installedBaseNode {
                id
                key
                title
            }
            assetLocation {
                id
                installedBaseNode {
                    id
                }
            }
        }
    }
`;
